export const Mobile = () => {
    return {
        open: false,

        toggle() {
            this.open = !this.open;
        },

        check(event) {
            const navWrapper = document.querySelector('.c-page-nav__wrapper');
            const hamburger = document.querySelector('.c-menu');

            if (!navWrapper.contains(event.target) && !hamburger.contains(event.target)) {
                this.open = false;
            }
        }
    }
}